module.exports = {"title":"Путеводитель по миру Такаси Мураками","description":"Читайте «Путеводитель по миру Такаси Мураками» и участвуйте в розыгрыше призов от Музея «Гараж» и компании «Ингосстрах»","image":"http://murakami.lenta.ru/img/shareicon.jpg","url":"http://murakami.lenta.ru/","fbappid":365568550580383,"trackingID":"UA-105301080-29","clientTrackingID":"","top100":0,"clientTop100":0,"yaMetrika":0}


//////////////////
// WEBPACK FOOTER
// ./js/meta.json
// module id = 332
// module chunks = 0